import React, { useMemo } from 'react';
import { useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { Operation } from '../../hooks/useOperations/types';
import { useFeatureFlagsConfigs } from '../../utils/sharedData';
import { useImpersonatedOperation } from '../../hooks/useImpersonatedOperation';


type PluginProps = {
  operations: Operation[];
  operationsSelected: Operation[];
};

const S3Plugin = React.lazy(() => importFromS3('dashboard'));
const MFPlugin = React.lazy(() => import('dashboard/Dashboard'));

export const DashboardPluginContainer = ({ operations, operationsSelected }: PluginProps) => {
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs());
  const useModuleFederation = featureFlags?.['web.dashboard.module-federation'];

  const DashboardPlugin = useModuleFederation ? MFPlugin : S3Plugin;

  const { operation: impersonatedOperation } = useImpersonatedOperation();
  // When the flag is on we derive the first operation from operationsSelected;
  // when off we derive it from operations where index 0 is the "All Operations" sentinel.
  const firstRealOperation = featureFlags?.['web-dashboard-operation-selector'] ? operationsSelected[0] : operations[1];
  const selectedOperations = useMemo(() => {
    if (impersonatedOperation) return [impersonatedOperation];
    // Undefined when the user has none, so fall back to an empty array instead
    // of passing [undefined] to the plugin.
    return firstRealOperation ? [firstRealOperation] : [];
  }, [impersonatedOperation, firstRealOperation]);

  return <DashboardPlugin operations={selectedOperations} />;
};
